<template>
  <div class="otp-container">
    <div class="otp-content">
      <h1 class="otp-title">首次登录绑定手机号</h1>
      <p class="otp-hint">请输入您的手机号码并获取验证码，完成首次登录绑定</p>

      <el-form :model="registerForm" :rules="registerRules" ref="registerForm" @submit.native.prevent>
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号码" maxlength="11">
            <i slot="prefix" class="el-icon-mobile-phone"></i>
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <div class="code-input-row">
            <el-input v-model="registerForm.code" placeholder="请输入短信验证码" maxlength="6" @input="onCodeInput">
              <i v-if="codeVerified === true" slot="suffix" class="el-icon-check code-icon code-icon-success"></i>
              <i v-if="codeVerified === false" slot="suffix" class="el-icon-close code-icon code-icon-error"></i>
            </el-input>
            <el-button
              type="primary"
              :disabled="sendCountdown > 0 || sendingCode"
              :loading="sendingCode"
              @click="sendRegisterCode"
              class="send-code-btn"
            >
              <span v-if="sendCountdown > 0">{{ sendCountdown }}s</span>
              <span v-else>获取验证码</span>
            </el-button>
          </div>
        </el-form-item>

        <!-- <div class="otp-message">
          <el-text v-if="errorMessage" type="danger">{{ errorMessage }}</el-text>
          <el-text v-else-if="successMessage" type="success">{{ successMessage }}</el-text>
        </div> -->

        <el-form-item>
          <el-button
            type="primary"
            class="otp-submit-button"
            :disabled="!codeVerified || registering"
            :loading="registering"
            @click="bindPhone"
          >
            绑定
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneRegister',
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    smsSendCodeUrl: {
      type: String,
      default: 'coupon-system/sms/sendCodeByPhone'
    },
    smsVerifyCodeUrl: {
      type: String,
      default: 'coupon-system/sms/verifyCodeByPhone'
    },
    updPhoneUrl: {
      type: String,
      default: '/coupon-system/updPhone'
    },
    // 区分管理员(admin)和商户(merchant)模式，影响绑定接口传参
    mode: {
      type: String,
      default: 'admin'
    },
    showBackBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      registerForm: {
        phone: '',
        code: ''
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '请输入6位数字验证码', trigger: 'blur' }
        ]
      },
      sendingCode: false,
      registering: false,
      errorMessage: '',
      successMessage: '',
      sendCountdown: 0,
      sendTimer: null,
      codeVerified: null, // null=未验证, true=通过, false=不通过
      codeVerifying: false
    }
  },
  methods: {
    onCodeInput(val) {
      // 只允许数字
      this.registerForm.code = val.replace(/\D/g, '')
      // 输入满6位自动验证
      if (this.registerForm.code.length === 6 && !this.codeVerifying) {
        this.verifyCode()
      } else if (this.registerForm.code.length < 6) {
        this.codeVerified = null
      }
    },
    verifyCode() {
      if (!this.registerForm.phone || !/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
        this.errorMessage = '请先输入正确的手机号码'
        return
      }
      const _this = this
      _this.codeVerifying = true
      _this.errorMessage = ''
      _this.$ajax({
        url: _this.smsVerifyCodeUrl + '?phoneNum=' + _this.registerForm.phone + '&code=' + _this.registerForm.code,
        methods: 'POST',
        token: window.sessionStorage.getItem('token'),
        success: function(response) {
          _this.codeVerifying = false
          if (response.code === 0) {
            _this.codeVerified = true
            _this.successMessage = '验证码验证通过'
            _this.errorMessage = ''
          } else {
            _this.codeVerified = false
            _this.errorMessage = response.message || '验证码验证失败'
          }
        },
        error: function() {
          _this.codeVerifying = false
          _this.codeVerified = false
          _this.errorMessage = '验证码验证失败'
        }
      })
    },
    sendRegisterCode() {
      if (!this.registerForm.phone || !/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
        this.errorMessage = '请输入正确的手机号码'
        return
      }
      const _this = this
      _this.sendingCode = true
      _this.errorMessage = ''
      _this.$ajax({
        url: _this.smsSendCodeUrl + '?phoneNum=' + _this.registerForm.phone,
        methods: 'POST',
        token: window.sessionStorage.getItem('token'),
        success: function(response) {
          _this.sendingCode = false
          if (response.code === 0) {
            _this.successMessage = '验证码已发送'
            _this.startSendCountdown()
          } else {
            _this.errorMessage = response.message || '发送验证码失败'
          }
        },
        error: function() {
          _this.sendingCode = false
          _this.errorMessage = '发送验证码失败'
        }
      })
    },
    startSendCountdown() {
      if (this.sendTimer) clearInterval(this.sendTimer)
      this.sendCountdown = 60
      this.sendTimer = setInterval(() => {
        this.sendCountdown--
        if (this.sendCountdown <= 0) {
          clearInterval(this.sendTimer)
          this.sendTimer = null
        }
      }, 1000)
    },
    bindPhone() {
      if (!this.codeVerified) return
      const _this = this
      _this.registering = true
      _this.errorMessage = ''
      _this.successMessage = ''
      // 根据模式构建不同的请求参数
      let reqData
      if (_this.mode === 'merchant') {
        // 商户模式：传 merchno 和 lxdh
        reqData = {
          merchno: _this.userInfo ? _this.userInfo.merchno : '',
          lxdh: _this.registerForm.phone
        }
      } else {
        // 管理员模式：传 id 和 newPhone
        reqData = {
          id: _this.userInfo ? _this.userInfo.id : '',
          newPhone: _this.registerForm.phone
        }
      }
      _this.$ajax({
        url: _this.updPhoneUrl,
        methods: 'POST',
        data: reqData,
        token: window.sessionStorage.getItem('token'),
        success: function(response) {
          _this.registering = false
          if (response.code === 0) {
            _this.successMessage = '绑定成功'
            if (_this.userInfo) {
              if (_this.mode === 'merchant') {
                _this.userInfo.lxdh = _this.registerForm.phone
              } else {
                _this.userInfo.phone = _this.registerForm.phone
              }
            }
            _this.$emit('register-success', _this.registerForm.phone)
          } else {
            _this.errorMessage = response.message || '绑定手机号失败'
          }
        },
        error: function() {
          _this.registering = false
          _this.errorMessage = '绑定手机号失败'
        }
      })
    }
  },
  beforeDestroy() {
    if (this.sendTimer) clearInterval(this.sendTimer)
  }
}
</script>

<style scoped>
.otp-container {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.otp-content {
  position: relative;
  width: 100%;
  max-width: 480px;
  text-align: center;
  max-height: 100vh;
  overflow-y: auto;
  padding: 10px 0;
}

.otp-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #303133;
}

.otp-hint {
  font-size: 14px;
  color: #606266;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

.code-input-row {
  display: flex;
  gap: 5%;
}

.code-input-row .el-input {
  width: 60%;
  flex: none;
}

.send-code-btn {
  width: 129px !important;
  flex: none;
}

.code-icon {
  font-size: 18px;
  line-height: 40px;
}

.code-icon-success {
  color: #67C23A;
}

.code-icon-error {
  color: #F56C6C;
}

.otp-message {
  min-height: 24px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-submit-button {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/phoneRegister.vue